export interface PurchaseContractLineHeader {
  id: string;
  purchaseContractHeaderId: string;
  contractNo: number;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  supplierReference: string;
  description: string;
  quantity: number;
  unitOfMeasure: string;
  price: number;
  contractValue: number;
  contractLineBalance: number;
  contractLineBalanceValue: number;
  availableDate: Date;
  canDelete: boolean;
}
